export default __webpack_public_path__ + "static/media/082209_0473.3bdae1d8.jpg";